import React, { useState, useEffect } from "react";
import { Card, CardContent, Grid, Typography, Box, Modal, Button } from "@material-ui/core";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import HelpIcon from '@material-ui/icons/Help';
import { calPowerValuesService } from "../model/service";
import { useSelector } from "react-redux";


const useStyles = makeStyles((theme) => ({
  skeleton:{
    display:"inline-block !important",
    width:"80px"
  },
    title:{
        marginBottom: "1rem",
        color:theme.palette.ePrimary?.base
    },
    values:{
        marginBottom: "0.5rem",
        color: theme.palette.eTertiary?.base
    },
    label:{
        marginBottom: "0.5rem",
        color: theme.palette.ePrimary?.base
    },
    questionMark:{
        color: theme.palette.eMedium?.base,
      },
      Boxstyle:{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor:theme.palette.ePrimary?.base,
        padding:'1em',
        color:theme.palette.eWhite?.base,
        border: 'solid 2px ' + theme.palette.eSecondary?.fifth,
        boxShadow: 24,
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        borderRadius:'8px'
      },
      modalCaption:{
        marginTop:'10px',
        color:theme.palette.eWhite?.base,
        fontSize:'1.3em',
        alignSelf:'center'
      }, modalBody:{
        textAlign:'left',
        alignSelf:'start',
        fontSize:'1em',
        color:theme.palette.eWhite?.base,
      },
      modalCloseBtn:{
        alignSelf:'center',
        color:theme.palette.ePrimary?.base,
        backgroundColor:theme.palette.eWhite?.base,
        marginTop:'10px',
        "&:hover": {
          color:theme.palette.ePrimary?.base,
          backgroundColor:theme.palette.eWhite?.base,
        }
      },
      hrLine:{
        border:'solid 1px ' + theme.palette.eWhite?.base,
        width:'100%'
      },
      documentTitle: {
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
      }, 
}));

export default function CALPOWERVALUES () {
    const classes = useStyles()
    const {t:labels, ready: labelReady} = useTranslation("label-E_CAL_POWER_VALUES")

    const [openModal,setOpenModal] = useState(false);
    const [data,setData] = useState(false)
    const customerNumber = useSelector((state)=> state?.meterDetails?.customerNumber)
    useEffect(()=>{
      if(customerNumber){
        calPowerValuesService.calPowerValues(customerNumber)
        .then((response) =>{
          setData(response?.data?.getMonthlyCalPowerValues)
        })
      }
    },[customerNumber])
   
    return(
        <>
        <CardContent>
        {
                labelReady ?
                <Typography variant="h6" className={classes.title}>
                <Box className={classes.documentTitle}>
                <Box><b>{labelReady?labels("E_CAL_POWER_VALUE"):""}</b></Box>
                {/* <HelpIcon className={classes.questionMark} onClick={()=>setOpenModal(true)}></HelpIcon>
                <Modal
                                open={openModal}
                                onClose={()=>setOpenModal(false)}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                              >
                                <Box className={classes.Boxstyle}>
                                  <Box display="flex" flexDirection="row" alignItems="space between">
                                    <Typography className={classes.modalCaption} variant="h6" >
                                     {labels("E_TOOL_HEADING")}
                                    </Typography>
                                  </Box>
                                  <hr className={classes.hrLine}/>

                                  <Typography className={classes.modalBody} variant="body">
                                      1.{labels("E_MONTHLY_MD")}<br/>{" "}{labels("E_TOOL_1")}
                                      
                                  </Typography>
                                  <br/>
                                  <Typography className={classes.modalBody} variant="body">
                                      2.{labels("E_LOAD_FACTOR")}<br/>
                                      {labels("E_TOOL_2")}<br/>
                                      {labels("E_TOOL_3")}
                                  </Typography>
                            
                                  <Button className={classes.modalCloseBtn} onClick={()=>setOpenModal(false)}>{labels("E_CLOSE_BUTTON")}</Button>
                                </Box>
                              </Modal> */}
                </Box></Typography>
                : <Skeleton />
            }
            <Grid container justify="space-between" direction='rows'style={{marginTop:'3rem'}}>
                <Grid item xs={12} md={7} direction='rows'>
                {
                labelReady ?
                <Typography variant="subtitle1" className={classes.label}><b>{labels("E_POWER_FACTOR")}</b> {data ? <span variant='subtitle1' className={classes.values}>{data?.powerFactor ? data?.powerFactor : data?.statusMessage2}</span>:<Skeleton className={classes.skeleton}/>} </Typography>
                : <Skeleton />
            }
                </Grid>
                <Grid item xs={12} md={5} direction='rows'>
                {
                labelReady ?
                <Typography variant="subtitle1" className={classes.label}><b>{labels("E_MAX_DEMAND")}</b> {data ? <span variant='subtitle1' className={classes.values}>{data?.maxDemand ? `${data?.maxDemand}${" "}${labels("E_KW")}`:data?.statusMessage1}</span> :<Skeleton className={classes.skeleton}/>}</Typography>
                : <Skeleton />
            }
                </Grid>
            </Grid>
            {/* <Grid container justify="space-between" direction='rows'>
            <Grid item xs={12} md={7} direction='rows'>
                {
                labelReady ?
                <Typography variant="subtitle1" className={classes.label}><b>{labels("E_MONTHLY_MD")}</b>{data ? <span variant='subtitle1' className={classes.values}>{data?.maxDemandOverLoadCounter?data?.maxDemandOverLoadCounter : data?.statusMessage4}</span> :<Skeleton className={classes.skeleton}/>}</Typography>
                : <Skeleton />
            }
                </Grid>
                <Grid item xs={12} md={5} direction='rows'>
                {
                labelReady ?
                <Typography variant="subtitle1" className={classes.label}><b>{labels("E_LOAD_FACTOR")}</b>{data ?<span variant='subtitle1' className={classes.values}>{data?.loadFactor ? `${data?.loadFactor} ${" "}${labels("E_PERCENTAGE")}` : data?.statusMessage3}</span> :<Skeleton className={classes.skeleton}/>}</Typography>
                : <Skeleton />
            }
                </Grid>
            </Grid> */}
        </CardContent>
        </>
    )
}